import { Signer } from 'ethers'
import { useEffect } from 'react'

import useBalance from 'hooks/useBalance'
import { initAccountAbstraction } from 'state/futures/actions'
import { selectTradingMode } from 'state/futures/common/selectors'
import { setAbstractionBalance, setTradingMode } from 'state/futures/reducer'
import { selectSessionValid } from 'state/futures/selectors'
import { TradingModes } from 'state/futures/types'
import { useAppDispatch, useAppSelector } from 'state/hooks'
import { selectAbstractionAddress } from 'state/wallet/selectors'

type UseAccountAbstractionConnectProps = {
	signer?: Signer | null
}

export default function useAccountAbstractionConnect({
	signer,
}: UseAccountAbstractionConnectProps) {
	const dispatch = useAppDispatch()

	const abstractionAddress = useAppSelector(selectAbstractionAddress)

	const tradingMode = useAppSelector(selectTradingMode)
	const isSessionActive = useAppSelector(selectSessionValid)

	const formattedBalance = useBalance(abstractionAddress)

	useEffect(() => {
		dispatch(initAccountAbstraction(signer))
	}, [signer, dispatch])

	useEffect(() => {
		if (tradingMode === TradingModes.DEFAULT && isSessionActive) {
			dispatch(setTradingMode(TradingModes.ONE_CLICK))
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch, isSessionActive])

	useEffect(() => {
		if (formattedBalance?.balance) {
			dispatch(setAbstractionBalance(formattedBalance.balance))
		}
	}, [formattedBalance, dispatch])
}
